<script setup lang="ts">
import { usePayslipItems } from '@/core/composables/salaries/usePayslipItems'
import { formatMoney } from '@spl-company-oy/core'
import { toRefs } from 'vue'

interface Props {
  /** Array of payslip items */
  items: PayslipItem[]
}

const props = defineProps<Props>()

const { items } = toRefs(props)

const { highlightedItems } = usePayslipItems(items)
</script>

<template>
  <div
    v-for="payslipItem in highlightedItems"
    :key="payslipItem.name"
    class="flex flex-row justify-between gap-x-1"
    :class="{ highlight: payslipItem.highlight }"
  >
    <span>
      {{ payslipItem.display_name }}
      {{ payslipItem.percent }}
    </span>
    <span class="text-right text-nowrap">
      {{ formatMoney(payslipItem.amount) }}
    </span>
  </div>
</template>

<style lang="scss" scoped>
@reference '../../../styles/main.css';

div.highlight {
  @apply py-3;
  @apply font-semibold;
  @apply border-y border-dashed border-secondary-200;
}
</style>
